import { MunicipalPropertyCatalogRow } from "@/domain/municipal-property/models/municipal-property-catalog-row.model";
import { MunicipalPropertyListPage } from "@/domain/municipal-property/models/municipal-property-list-page.model";

interface FlattenedMunicipalPropertyPageList {
  propertyList: MunicipalPropertyCatalogRow[];
  totalCount: number;
}

export function flattenMunicipalPropertyPageList(
  pageList: readonly MunicipalPropertyListPage[],
): FlattenedMunicipalPropertyPageList {
  return {
    propertyList: pageList.flatMap((page) => page.nodeList),
    totalCount: pageList[0]?.totalCount ?? 0,
  };
}
